export default {};

// 0: "非讯达" ,600: "X讯达", 601: "车讯达", 602: "房讯达"; 603: "家讯达"
export const isXunda = (value) => {
  const code = window.pageProps.xundaOuterCode;
  if (!/^60\d$/.test(code)) return false;
  if (value === undefined) return true;
  if (typeof value !== 'string') return false;
  const codeMap = new Map([
    [601, ['cxd', '车', '车讯达']],
    [602, ['fxd', 'eft', '房', '鹅房通']],
    [603, ['jxd', '家', '家讯达']],
  ]);
  const typeMap = {};
  for (const [key, value] of codeMap) {
    value.forEach((name) => {
      typeMap[name] = key;
    });
  }
  return typeMap[value] === code;
};

/**
 * 判断当前登录的账号是否是房讯达账号
 * @returns boolean
 */
export const judgeIsFxd = () => {
  return isXunda('fxd');
};

export const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};

/**
 * 判断当前页面是否为TMC内嵌
 * @returns boolean
 */
 export const judgeIsFromTMC = () => {
  return getQueryVariable('from') === 'tmc';
};

